import { render, staticRenderFns } from "./noplate.vue?vue&type=template&id=3b769f6c&"
import script from "./noplate.vue?vue&type=script&lang=js&"
export * from "./noplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports